import { ICaptionsItem, PlayerStates } from '../../../../types/common';
import React from 'react';

export enum ECaptionsItemType {
  TARGET,
  NATIVE
}

export interface ITargetCaptionsFields {
  elementRef?: React.RefObject<HTMLDivElement>;
  captions: ICaptionsItem[];
  videoId: string,
  langCode: string,
  groupLangName: string,
  solo: boolean
  playerActive: boolean;
  forwardCaptionIndex: number;
  listenerHolder: IPlayerListenerHolder,
  showTranslations?: boolean;
  playerExist: boolean;
  loadCaptionsError?: boolean;
}

export interface ITargetCaptionsEvents {
  onCaptionPlay: (caption: ICaptionsItem, isPause: boolean) => void;
  onCaptionDblClick: (index: number, caption: ICaptionsItem) => void;
  onCaptionMouseEnter: (index: number) => void;
  onCaptionMouseLeave: (index: number) => void;
  onCaptionMouseDown: (index: number) => void;
  onMouseLeave: () => void;
  onMouseEnter: () => void;
  onChangeActiveIndex: (index: number) => void;
  onCheckLoadCaptions?: () => Promise<any>;
}

export interface ITargetCaptionsProps extends
  ITargetCaptionsFields,
  ITargetCaptionsEvents
{}

export interface ITargetCaptionItemFields {
  index: number;
  startTime: number;
  endTime: number;
  captionText: string;
  isActive?: boolean;
  type: ECaptionsItemType;
  playerActive?: boolean;
  showTranslations?: boolean;
  showPlayPause: boolean;
  userName?: string;
  // speaker's position in the caption set, used to pick their color; undefined => unknown speaker
  userColorIndex?: number;
}
export interface ITargetCaptionItemEvents {
  onPlayPauseClick: (index: number) => void;
  onItemDblClick: (index: number, wordIndex: number) => void;
  onMouseEnter: (index: number) => void;
  onMouseLeave: (index: number) => void;
  onSetHeight?: (index: number, height: number) => void;
}

export interface ITargetCaptionItemProps extends
  ITargetCaptionItemFields,
  ITargetCaptionItemEvents
{}

export type TOnTargetIndexChange = (index: number) => void;

export interface IPlayerListener {
  onTargetIndexChange: TOnTargetIndexChange,
  onTargetWordIndexChange?: TOnTargetIndexChange
}

export interface IPlayerListenerHolder {
  addListener: (listener: IPlayerListener) => void;
  removeListener: (listener: IPlayerListener) => void;
}

export type TTooltipPlacement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
